<template>
	<div class="drawer">
		<el-drawer
		size="1200px"
		title="用户信息"
		:visible.sync="drawerStatus"
		@close='close'
		>
			<el-table :data="couponList" height="100%">
				<el-table-column label="优惠券名称" min-width="150">
					<template slot-scope="scope">
						<el-radio v-model="radio" :label="scope.row.id" @change="changeRadio">
							{{scope.row.coupon_name}}
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column label="面额">
					<template slot-scope="scope">
						<span>{{scope.row.money_reduce}}</span>
					</template>
				</el-table-column>
				<el-table-column label="规格" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.activity_type==1">满{{scope.row.money_top}}减{{scope.row.money_reduce}}</span>
						<span v-if="scope.row.activity_type==2">满{{scope.row.rebate_top}}打{{scope.row.rebate*10}}折 最高抵扣{{scope.row.rebate_limit}}
							元</span>
					</template>
				</el-table-column>
				<!-- <el-table-column label="优惠卷类型" width="180">
					<template slot-scope="scope">
						<span v-for="(item,index) in scope.row.coupon_type" :key='index'>
							<span v-if = 'item==1' style="margin-left: 5px;">商品</span>
							<span v-if = 'item==2' style="margin-left: 5px;">洗美</span>
							<span v-if = 'item==3' style="margin-left: 5px;">病例</span>
							<span v-if = 'item==4' style="margin-left: 5px;">疫苗驱虫</span>
							<span v-if = 'item==5' style="margin-left: 5px;">医疗服务</span>
							<span v-if = 'item==6' style="margin-left: 5px;">寄养</span>
							<span v-if = 'item==7' style="margin-left: 5px;">挂号</span>
							<span v-if = 'item==8' style="margin-left: 5px;">活体</span>
							<span v-if = 'item==9' style="margin-left: 5px;">虚拟</span>
							<span v-if = 'item==10' style="margin-left: 5px;">订金</span>
						</span>
					</template>
				</el-table-column> -->
				
				<el-table-column label="使用时间" width="180">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.use_start_time,'YYYY-MM-DD')}}</span> 至 <span>{{$public.FTime(scope.row.use_end_time,'YYYY-MM-DD')}}</span>
					</template>
				</el-table-column>
				<el-table-column label="说明" width="170" >
					<template slot-scope="scope">
						<div style="display: flex;justify-content: center;align-items: center;">
							<span class="remark">{{scope.row.remark}}</span>
							<el-popover v-if="scope.row.remark" placement="top-start" width="200" trigger="hover" :content="scope.row.remark">
								<el-button slot="reference" type="text" icon="el-icon-view"></el-button>
							</el-popover>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- <div style="height: 40px;width:100%;"></div> -->
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				couponList:[],
				radio:'',
				curCouponObj:{},
			}
		},
		computed:{
			
		},
		props:{
			userInfo:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{this.drawerStatus=true})
			this.getCouponList()
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 选择优惠券
			changeRadio(){
				console.log(this.radio)
				this.curCouponObj = this.$public.getMatchingItem(this.couponList,'id',this.radio)
			},
			// 保存基本信息
			submit() {
				let params = {
					"member_id": this.userInfo._id,
					"member_name": this.userInfo.basic_info.nick_name,
					"member_mobile": this.userInfo.basic_info.user_mobile,
					"other_param": '',
					"remark": '',
					"coupon_list": [
						{
							"coupon_id": this.curCouponObj.id,
							"coupon_count": 1,
						}
					],
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_member+'/api/middleware/Coupon/HandSendCoupon', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit("submit",{type:'success',data:''})
					}
				})
			},
			getCouponList(){
				let params = {
					useScene:2, // 2：线下
					"pageIndex": 1,
					"pageSize": 1000,
				}
				this.$http.post(process.env.VUE_APP_Url_baseData+'/api/product/coupons/list', params).then(res => {
					if(res.code===0){
						this.couponList = res.data.data;
						// console.log(res.data.data)
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				height: 100%;
				overflow-y: auto;
				padding-bottom: 40px;
				box-sizing: border-box;
			}
		}
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: $mainColor;
				}
			}
		}
	}
	
</style>
